'use client';

import * as React from 'react';
import { useSelectRootContext } from "../root/SelectRootContext.js";
import { useRenderElement } from "../../utils/useRenderElement.js";

/**
 * A text label of the currently selected item.
 * Renders a `<span>` element.
 *
 * Documentation: [Base UI Select](https://base-ui.com/react/components/select)
 */
export const SelectValue = /*#__PURE__*/React.forwardRef(function SelectValue(componentProps, forwardedRef) {
  const {
    className,
    render,
    children,
    placeholder,
    ...elementProps
  } = componentProps;
  const {
    value,
    label,
    valueRef
  } = useSelectRootContext();
  const element = useRenderElement('span', componentProps, {
    ref: [forwardedRef, valueRef],
    props: [{
      children: typeof children === 'function' ? children(!label && placeholder ? placeholder : label, value) : label || placeholder
    }, elementProps]
  });
  return element;
});
if (process.env.NODE_ENV !== "production") SelectValue.displayName = "SelectValue";